import { render, staticRenderFns } from "./tableD.vue?vue&type=template&id=3ff20649&"
import script from "./tableD.vue?vue&type=script&lang=js&"
export * from "./tableD.vue?vue&type=script&lang=js&"
import style0 from "./tableD.vue?vue&type=style&index=0&id=3ff20649&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports